import * as m from "@/paraglide/messages"
import { cn } from "@/shared/lib/utils"
import { SCENARIOS_TOTAL } from "../model/constants"
import { ScenarioBall } from "./scenario-ball"

type ScenarioCounterProps = {
	played: number
	size: "sm" | "md"
	showLabel?: boolean
	className?: string
}

export function ScenarioCounter({
	played,
	size,
	showLabel,
	className,
}: ScenarioCounterProps) {
	const track = (
		<div
			className={cn(
				"flex items-center gap-1",
				size === "md" && "rounded-2xl bg-white p-1",
				!showLabel && className,
			)}
		>
			{Array.from({ length: SCENARIOS_TOTAL }, (_, index) => (
				<ScenarioBall
					// biome-ignore lint/suspicious/noArrayIndexKey: balls come from a fixed count, never reordered
					key={index}
					size={size}
					filled={index < played}
					className={
						size === "md"
							? "bg-[#d9dce5]"
							: cn(
									"bg-[#5d6479]/15",
									index >= played &&
										"shadow-[inset_-2px_2px_4px_0px_rgba(0,0,0,0.05)]",
								)
					}
				/>
			))}
		</div>
	)

	if (!showLabel) return track

	return (
		<div className={cn("flex w-full flex-col items-center gap-1", className)}>
			{track}
			<p className="text-center text-[12px] leading-3.75 font-semibold text-white/50">
				{m.scenarioPlayedCount({ played, total: SCENARIOS_TOTAL })}
			</p>
		</div>
	)
}
